import React from 'react'
import { withTranslation } from 'react-i18next'
import AddListItemButton from '../../../Controls/AddListItemButton'
import Question from '../components/Question'
import { InView } from 'react-intersection-observer'

const QuestionList = props => {
    const { tmpStructure, validationStructure, tabsValidationResult, methods, t } = props

    const handleOnScrollHighlightVisibleItem = async (inView, entry) => {
        if (inView) await methods.setFocusToQuestion(entry.target)
    }

    return (
        <>
            {tmpStructure.questions.length ? (
                <ul className={`list${!methods.canDo('add', 'questions') ? ' is-full' : ''}`}>
                    {tmpStructure.questions.map((question, qIndex) => {
                        return (
                            <InView
                                as="li"
                                key={question.id}
                                onChange={handleOnScrollHighlightVisibleItem}
                                id={question.id}
                                threshold={[0.5]}
                            >
                                <Question
                                    question={question}
                                    validationStructure={validationStructure}
                                    tabsValidationResult={tabsValidationResult}
                                    methods={methods}
                                    qIndex={qIndex}
                                />
                            </InView>
                        )
                    })}
                </ul>
            ) : null}
            {methods.canDo('add', 'questions') ? (
                <AddListItemButton
                    title={t('Add question')}
                    length={tmpStructure.questions.length}
                    onClick={() => methods.onAdd('questions', { scrollContent: true, scrollAside: false })}
                />
            ) : null}
        </>
    )
}

export default withTranslation('translations')(QuestionList)
